(() => {
  document.querySelectorAll('[data-rose-page]').forEach((root) => {
    const cards = Array.from(root.querySelectorAll('[data-rose-card]'));
    const colors = Array.from(root.querySelectorAll('[data-color-choice]'));
    const counts = Array.from(root.querySelectorAll('[data-count-choice]'));
    const picker = root.querySelector('.rcr-picker');
    const stage = root.querySelector('.rcr-stage');
    const announcement = root.querySelector('[data-selection-announcement]');
    const summary = root.querySelector('[data-selection-summary]');
    const moreSelected = root.querySelector('[data-more-selected]');
    if (!cards.length || !colors.length || !counts.length || !picker) return;

    let selectedColor = 'red';
    let selectedCount = '50';
    const render = (announce = false) => {
      const selected = cards.find((card) => card.dataset.count === selectedCount && card.dataset.color === selectedColor);
      if (!selected) return;
      cards.forEach((card) => card.classList.toggle('is-active', card === selected));
      colors.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.colorChoice === selectedColor)));
      counts.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.countChoice === selectedCount)));
      if (moreSelected) moreSelected.hidden = selectedCount !== '365';
      const image = selected.querySelector('img');
      if (image && image.loading === 'lazy') image.loading = 'eager';
      if (summary) {
        const summaryImage = summary.querySelector('[data-selected-image]');
        const summaryAction = summary.querySelector('[data-selected-action]');
        const summaryPreview = summary.querySelector('[data-selected-preview]');
        const productAction = selected.querySelector('a.rcr-product__action');
        if (image && summaryImage) summaryImage.src = image.currentSrc || image.src;
        summary.querySelector('[data-selected-title]').textContent = selected.querySelector('h2')?.textContent.trim() || '';
        const summaryPrice = summary.querySelector('[data-selected-price]');
        const productPrice = selected.querySelector('.rcr-product__price');
        if (summaryPrice && productPrice) summaryPrice.replaceChildren(...Array.from(productPrice.childNodes, (node) => node.cloneNode(true)));
        window.rdbCurrencyPrices?.refresh();
        summaryAction.hidden = !productAction;
        summaryPreview.hidden = !!productAction;
        if (productAction) summaryAction.href = productAction.href;
        else summaryAction.removeAttribute('href');
        summary.hidden = false;
      }
      if (announce && announcement) announcement.textContent = `${selected.querySelector('h2')?.textContent.trim() || ''}, ${selected.querySelector('.rcr-product__price')?.textContent.trim() || ''}, ${selected.querySelector('.rcr-product__note')?.textContent.trim() || ''}`;
      return selected;
    };

    root.dataset.ready = 'true';
    render();
    colors.forEach((button) => button.addEventListener('click', () => {
      selectedColor = button.dataset.colorChoice;
      render(true);
    }));
    counts.forEach((button) => button.addEventListener('click', () => {
      selectedCount = button.dataset.countChoice;
      render(true);
    }));
    root.querySelectorAll('[data-pick-count][data-pick-color]').forEach((button) => {
      button.addEventListener('click', () => {
        selectedCount = button.dataset.pickCount;
        selectedColor = button.dataset.pickColor;
        const selected = render(true);
        (stage || picker).scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        selected?.focus({ preventScroll: true });
      });
    });

    const pair = root.querySelector('[data-rose-reveal]');
    if (pair && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pair.classList.add('rcr-motion');
      const items = Array.from(pair.querySelectorAll('.rcr-pair__item'));
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.24 });
      items.forEach((item) => observer.observe(item));
    }
  });
})();


(() => {
  const initialize = () => {
    document.querySelectorAll('[data-rose-browse]').forEach((browse) => {
      if (browse.classList.contains('is-ready')) return;
      const tabs = Array.from(browse.querySelectorAll('[data-browse-tab]'));
      const panels = Array.from(browse.querySelectorAll('[data-browse-panel]'));
      const tablist = browse.querySelector('[data-browse-tabs]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (tabs.length === 3 && panels.length === 3 && tablist) {
        const inlineDirection = (element) => getComputedStyle(element).direction === 'rtl' ? -1 : 1;
        const updateRail = (panel) => {
          const rail = panel.querySelector('[data-browse-rail]');
          const controls = panel.querySelector('[data-browse-controls]');
          if (!rail || !controls || panel.hidden) return;
          const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
          controls.hidden = maxScroll < 2;
          const offset = Math.min(maxScroll, Math.max(0, rail.scrollLeft * inlineDirection(rail)));
          const position = offset / (maxScroll || 1);
          controls.querySelector('[data-browse-prev]').disabled = offset < 2;
          controls.querySelector('[data-browse-next]').disabled = offset >= maxScroll - 2;
          const progress = controls.querySelector('[data-browse-progress]');
          const fraction = Math.min(1, Math.max(0.25, rail.clientWidth / (rail.scrollWidth || 1)));
          progress.style.width = `${fraction * 100}%`;
          progress.style.transform = `translateX(${inlineDirection(progress) * position * (100 / fraction - 100)}%)`;
        };
        const selectTab = (nextTab, moveFocus = false) => {
          tabs.forEach((tab) => {
            const active = tab === nextTab;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.browsePanel !== nextTab.dataset.browseTab;
          });
          if (moveFocus) nextTab.focus();
          const activePanel = panels.find((panel) => !panel.hidden);
          if (activePanel) requestAnimationFrame(() => updateRail(activePanel));
        };
        browse.classList.add('is-ready');
        panels.forEach((panel) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabs.find((tab) => tab.dataset.browseTab === panel.dataset.browsePanel)?.id || '');
          const rail = panel.querySelector('[data-browse-rail]');
          const prev = panel.querySelector('[data-browse-prev]');
          const next = panel.querySelector('[data-browse-next]');
          const move = (direction) => {
            const card = rail.querySelector('.rcr-browse__card');
            const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
            rail.scrollBy({ left: direction * inlineDirection(rail) * ((card?.getBoundingClientRect().width || rail.clientWidth) + gap), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
          };
          prev.addEventListener('click', () => move(-1));
          next.addEventListener('click', () => move(1));
          rail.addEventListener('scroll', () => updateRail(panel), { passive: true });
          rail.addEventListener('keydown', (event) => {
            if (event.target !== rail) return;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault();
              move((event.key === 'ArrowLeft' ? -1 : 1) * inlineDirection(rail));
            } else if (event.key === 'Home' || event.key === 'End') {
              event.preventDefault();
              rail.scrollTo({ left: event.key === 'Home' ? 0 : inlineDirection(rail) * (rail.scrollWidth - rail.clientWidth), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
            }
          });
        });
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => selectTab(tab));
          tab.addEventListener('keydown', (event) => {
            let nextIndex;
            if (event.key === 'ArrowRight') nextIndex = (index + inlineDirection(tablist) + tabs.length) % tabs.length;
            else if (event.key === 'ArrowLeft') nextIndex = (index - inlineDirection(tablist) + tabs.length) % tabs.length;
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = tabs.length - 1;
            else return;
            event.preventDefault();
            selectTab(tabs[nextIndex], true);
          });
        });
        tablist.hidden = false;
        selectTab(tabs[0]);
        window.addEventListener('resize', () => panels.forEach(updateRail));
      }
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

// The offer sticker arrives once; the flowers and shopping controls stay still.
(() => {
  if (!('IntersectionObserver' in window)) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  const pending = new Set();
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const sticker = entry.target.querySelector('.rcr-browse__sale-heading');
      sticker?.classList.remove('is-reveal-pending');
      pending.delete(sticker);
      if (!sticker || reducedMotion.matches || typeof sticker.animate !== 'function') return;
      const restingTransform = getComputedStyle(sticker).transform;
      const animation = sticker.animate([
        { transform: `translateX(calc(100% + 32px)) ${restingTransform}`, opacity: 0 },
        { transform: restingTransform, opacity: 1 }
      ], { duration: 520, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
      animations.add(animation);
      const release = () => animations.delete(animation);
      animation.addEventListener('finish', release, { once: true });
      animation.addEventListener('cancel', release, { once: true });
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -12% 0px' });
  const initialize = () => {
    document.querySelectorAll('.rcr-browse__sale-heading').forEach((sticker) => {
      if (sticker.dataset.saleRevealReady) return;
      sticker.dataset.saleRevealReady = 'true';
      if (!reducedMotion.matches && typeof sticker.animate === 'function') {
        sticker.classList.add('is-reveal-pending');
        pending.add(sticker);
        observer.observe(sticker.parentElement);
      }
    });
  };
  reducedMotion.addEventListener('change', () => {
    if (!reducedMotion.matches) return;
    observer.disconnect();
    pending.forEach((sticker) => sticker.classList.remove('is-reveal-pending'));
    pending.clear();
    animations.forEach((animation) => animation.cancel());
    animations.clear();
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
